<!--============================
=            BADGES            =
=============================-->
<template>
  <!-- bADGES -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Badges</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Bottom</div>
          <div slot="card-body">
            <div>
              <div class="text-center">
                <v-badge color="red" bottom>
                  <template v-slot:badge>
                    <v-icon dark>mdi-close</v-icon>
                  </template>
                  <span>Badge w/ Bottom Prop</span>
                </v-badge>
              </div>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Left</div>
          <div slot="card-body">
            <div class="text-center">
              <v-badge color="teal" left>
                <template v-slot:badge>
                  <v-icon dark>mdi-check</v-icon>
                </template>
                <span>Badge w/ Left Prop</span>
              </v-badge>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Overlap</div>
          <div slot="card-body">
            <div class="text-center">
              <v-badge color="purple" left overlap>
                <template v-slot:badge>
                  <v-icon dark>mdi-check</v-icon>
                </template>
                <v-icon color="grey lighten-1" large>account_circle</v-icon>
              </v-badge>

              <v-badge overlap color="orange">
                <template v-slot:badge>
                  <v-icon dark>mdi-bell</v-icon>
                </template>
                <v-icon large color="grey darken-1">account_box</v-icon>
              </v-badge>
            </div>
          </div>
        </base-card>
      </v-col>

      <!-- badges icons -->
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Icon</div>
          <div slot="card-body">
            <div class="text-center">
              <v-badge left color="purple">
                <template v-slot:badge>
                  <v-icon dark>mdi-adjust</v-icon>
                </template>
                <span>MDI icon</span>
              </v-badge>&nbsp;&nbsp;
              <v-badge color="orange">
                <template v-slot:badge>
                  <v-icon dark>fa fa-fighter-jet</v-icon>
                </template>
                <span>Font Awesome icon</span>
              </v-badge>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Inline -->
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Inline</div>
          <div slot="card-body">
            <div class="text-center">
              <v-badge left>
                <template v-slot:badge>
                  <span>2</span>
                </template>
                <span>Examples</span>
              </v-badge>&nbsp;&nbsp;
              <v-badge color="green">
                <template v-slot:badge>
                  <v-icon dark>mdi-format-list-bulleted-square</v-icon>
                </template>
                <span>Lists</span>
              </v-badge>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- visibility -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Visibility</div>
          <div slot="card-body">
            <v-container fluid class="text-center">
              <v-row justify="space-between">
                <v-col cols="12">
                  <v-btn color="indigo" class="white--text" @click="show1 = !show1">Toggle</v-btn>
                </v-col>

                <v-col cols="12" class="mt-12">
                  <v-badge v-model="show1" color="cyan" left>
                    <template v-slot:badge>
                      <span>6</span>
                    </template>
                    <v-icon large color="grey lighten-1">shopping_cart</v-icon>
                  </v-badge>

                  <v-badge v-model="show1" color="purple">
                    <template v-slot:badge>
                      <span>6</span>
                    </template>
                    <v-icon large color="grey">mdi-email</v-icon>
                  </v-badge>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>

      <!-- Show-on-hover-->
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Show-on-hover</div>
          <div slot="card-body">
            <v-container fluid class="text-center">
              <v-row justify="center">
                <v-badge v-model="show2" color="cyan" left>
                  <template v-slot:badge>
                    <span>6</span>
                  </template>
                  <v-icon
                    large
                    color="grey lighten-1"
                    @mouseover="show = true"
                    @mouseout="show = false"
                  >shopping_cart</v-icon>
                </v-badge>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <!-- Dynamic notifications -->
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Dynamic notifications</div>
          <div slot="card-body">
            <v-container fluid class="text-center">
              <v-row justify="space-around">
                <div>
                  <v-btn class="mx-1" color="primary" @click="messages++">Send Message</v-btn>
                  <v-btn class="mx-1" color="error" @click="messages = 0">Clear Notifications</v-btn>
                </div>
                <v-badge color="green" overlap>
                  <template v-slot:badge>
                    <span v-if="messages > 0">{{ messages }}</span>
                  </template>
                  <v-icon large>mdi-email</v-icon>
                </v-badge>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },

  data() {
    return {
      show1: true,
      show2: false,
      show3: false,
      messages: 0
    };
  }
};
</script>


<!--====  End of BADGES  ====-->
